export const sendVerificationEmail = async(email, firstName, lastName, captchaToken = '') => {
	const response = await fetch('/api/send-verification-email', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email,
        first_name: firstName,
        last_name: lastName,
        ...(captchaToken && { h_captcha_response: captchaToken }),
      }),
    });
    const text = await response.text();
    let data = {};
    try {
      data = text ? JSON.parse(text) : {};
    } catch (_) {
      // Rate limit or non-JSON response
    }
    if (!response.ok) {
      if (response.status === 429) {
        throw new Error('Too many sign-up attempts. Please wait 30 seconds and try again.');
      }
      throw new Error(data?.error || data?.message || 'Failed to send verification email.');
    }
    console.log(data)
}

export const verificationEmail = async (email, code) => {
  try {
    const response = await fetch('/api/verify-code', { // Replace with your actual API endpoint
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email, code }),
    });

    const data = await response.json();

    if (!response.ok) {
      if (response.status === 404) {
        throw new Error('Failed to verify email. Please try again. If this problem continues, please contact support at 412-231-9310');
      }
      if (response.status === 409) {
        throw new Error(data?.error || 'You are already in the sign-up queue. Our team will process your request shortly.');
      }
      if (response.status === 400) {
        throw new Error(data?.error || 'An error occurred. Please check the verification code and try again.');
      }
      throw new Error(data?.message || 'An unexpected error occurred.');
    }
  } catch (error) {
    console.error('Verification failed:', error.message);
    throw error; // Rethrow the error for the caller to handle
  }
};